if (!window.beaePageJS) {
                                    window.beaePageJS = [];
                                }
                                let jsHandle_6489f68fae1188500c61ba52 = () => {
                    if (document.querySelector('.beae-s82h4hwn:not([data-beae-bind])')) {
                        (function() {this.$el&&this.$el.querySelector(".beae-section-background-video")&&typeof handleVideoBg<"u"&&this.isLive&&(handleVideoBg.bind(this)(),window.addEventListener("resize",handleVideoBg.bind(this)))}).call({
                            $el: document.querySelector('.beae-s82h4hwn:not([data-beae-bind])'),
                            
                            id: 'beae-s82h4hwn',
                            isLive: true
                        });
                        document.querySelector('.beae-s82h4hwn:not([data-beae-bind])').setAttribute('data-beae-bind', true);
                    }
                
                    if (document.querySelector('.beae-lrelet63:not([data-beae-bind])')) {
                        (function() {this.$el&&this.$el.querySelector(".beae-section-background-video")&&typeof handleVideoBg<"u"&&this.isLive&&(handleVideoBg.bind(this)(),window.addEventListener("resize",handleVideoBg.bind(this)))}).call({
                            $el: document.querySelector('.beae-lrelet63:not([data-beae-bind])'),
                            
                            id: 'beae-lrelet63',
                            isLive: true
                        });
                        document.querySelector('.beae-lrelet63:not([data-beae-bind])').setAttribute('data-beae-bind', true);
                    }
                }
                                if (window.beaejQuery) {
                                    jsHandle_6489f68fae1188500c61ba52()
                                } else {
                                    window.beaePageJS.push(jsHandle_6489f68fae1188500c61ba52)
                                }